import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LINK_TYPES } from 'MeetingsBase/constants/enums';
import { getBookInfo, getHasAbsoluteZeroAvailability, getRotationsRoundRobinProfile } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getLongDisplayName } from 'MeetingsLib/utils/utils';
import { Big } from 'foundations-components/transitional/components/Big';
import { H4 } from 'foundations-components/transitional/components/H4';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ZeroState(props) {
  /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  const bookInfo = useSelector(getBookInfo);
  const hasAbsoluteZeroAvailability = useSelector( /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  getHasAbsoluteZeroAvailability);
  const rotationsRoundRobinProfile = useSelector( /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  getRotationsRoundRobinProfile);
  const alternativeProfile = bookInfo.get('linkType') === LINK_TYPES.get('roundRobin') ? rotationsRoundRobinProfile : null;
  const {
    linkUse,
    profile,
    TimePickerMarker
  } = props;
  const email = alternativeProfile ? alternativeProfile.email : profile.email;
  const renderZeroStateText = () => {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "prebook.timeOptions.zeroState_jsx",
      options: {
        href: `mailto:${email}`,
        external: true,
        use: linkUse,
        email
      },
      elements: {
        Link
      }
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(H4, {
      role: "alert",
      tabIndex: 1,
      "aria-level": 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: hasAbsoluteZeroAvailability ? 'prebook.timeOptions.sorryEmptyAvailability' : 'prebook.timeOptions.sorry',
        options: {
          fullName: getLongDisplayName(alternativeProfile || profile)
        }
      })
    }), /*#__PURE__*/_jsx(Big, {
      children: renderZeroStateText()
    }), /*#__PURE__*/_jsx(TimePickerMarker, {})]
  });
}